import { createRouter, createWebHistory } from 'vue-router'
import SuperTurbo from './superturbo.vue'
import { stayInsideEmbed } from '../../shared/embed.js'

const DEFAULT_APPLICATION = 'TURBO'

const routes = [
  {
    path: '/',
    redirect: `/${DEFAULT_APPLICATION}`
  },
  {
    path: '/:application',
    component: SuperTurbo,
    homepage: true
  },
  {
    path: '/:application/:pathSegments+',
    component: SuperTurbo
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from) => {

  if (to.path.length > 1 && to.path.endsWith('/')) {

    return {
      path: to.path.replace(/\/+$/, ''),
      query: to.query,
      hash: to.hash,
      replace: true
    }
  }

  const stayed = stayInsideEmbed(from && from.path, to.path)

  if (stayed && stayed !== to.path) {

    return {
      path: stayed,
      query: to.query,
      hash: to.hash
    }
  }

  if (!from.matched.length) return

  const decide = window.__superturbo_modalNavigation

  if (typeof decide === 'function' && decide(to, from)) return false
})

export default router
